(function (upp) {
    'use strict';
    upp
        .service('outletsService', ['productsDao',
        function (ProductsDao) {

            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "v2/outlets";

            var dao = ProductsDao.create(URL_API_REST_SERVER);

            /**
             * Returns the list of available products in the eshop and the currency
             *
             * @method listOutletsProducts
             * @return {Promise} Returns a promise that will be fulfilled(Array of products and currency object) or rejected(error)
             */
            var listOutletsProducts = function () {
                return dao.listProducts();
            };


            return{
                listOutletsProducts:listOutletsProducts
            };
        }])
    ;
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/outlets/services/outlets-services.js